import useCustomers from "../useCustomers";

export const toggleStatusItem = (id, statuses) => {
  const newStatuses = [...statuses];

  if (newStatuses.includes(id)) {
    return newStatuses.filter((x) => x !== id);
  }
  newStatuses.push(id);

  return newStatuses;
};

const useReviewsFilters = () => {
  const data = useCustomers();
  const { reviewStatusIds, reviewStatusCounts, setState } = data;

  const onStatusChange = (id) => {
    const toggled = toggleStatusItem(id, reviewStatusIds);
    const newStatusIds =
      toggled.length > 0 ? toggled : reviewStatusCounts.map((x) => x.key);

    setState({ reviewStatusIds: newStatusIds, pageNumber: 1 });
  };

  const onDatesChange = (_, { name, value }) =>
    setState({ [name]: value, pageNumber: 1 });

  return {
    ...data,
    onStatusChange,
    onDatesChange,
  };
};

export default useReviewsFilters;
